import YouTube, { YouTubeProps } from "react-youtube";
import { useNavigate, useParams } from "react-router-dom";
import { SmallBackButton } from "../../../../core/components/CustomButton";
import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";

export const TutorialVideoScreen = () => {
	const navigate = useNavigate();
	const { videoId } = useParams();

	const videoOptions: YouTubeProps["opts"] = {
		width: "100%",
		height: "260px",
		playerVars: {
			autoplay: 1,
		},
	};

	return (
		<Column className="bg-white p-6 md:p-8 gap-4 md:gap-5 max-md:overflow-y-auto">
			<SmallBackButton onClick={() => navigate("/settings/tutorial")} className="mb-2" />
			<TextComponent variant="h2" className="font-bold">
				Tutorial
			</TextComponent>
			{videoId ? (
				<div className="overflow-hidden rounded-xl bg-black">
					<YouTube
						videoId={videoId}
						opts={videoOptions}
						className="w-full"
					/>
				</div>
			) : null}
		</Column>
	);
};
